export const isRenterAIFeatureStatus = ({
    isRenterAIEnabled,
    isGlobalAIEnabled,
    hasActiveServicePlan,
    servicePlanUsers
}) => {
    if (hasActiveServicePlan) {
        return true;
    }
    if (isGlobalAIEnabled === 'true' && isRenterAIEnabled === 'true') {
        return true
    }

    if (isGlobalAIEnabled === 'true' && servicePlanUsers === 'true') {
        return false;
    }
};

export const isOwnerAIFeatureStatus = ({
    isOwnerAIEnabled,
    isGlobalAIEnabled,
    hasActiveServicePlan,
    servicePlanUsers
}) => {

    if (hasActiveServicePlan) {
        return true;
    }

    if (isGlobalAIEnabled === 'true' && isOwnerAIEnabled === 'true') {
        return true
    }

    if (isGlobalAIEnabled === 'true' && servicePlanUsers === 'true') {
        return false;
    }
};